<template>
	<router-link :to="link" class="card" @click="toActivity" :class="{lower: isLower}">
		<div class="star" v-if="starClass" :class="starClass">
			<div class="star-inner"></div>
		</div>
		<div class="image">
			<img :src="image">
		</div>
		<div class="title">{{ title }}</div>
		<div class="text">{{ text }}</div>
		<div class="number">{{ number }}</div>
		<img src="@/assets/badge.png" class="badge" v-if="afisha">
	</router-link>
</template>

<script>
import { CARDS } from '@/config'

export default {
	props: {
		id: Number,
		reverse: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		afisha() {
			return CARDS[this.id - 1].afisha
		},
		link() {
			return '/activity/' + this.id
		},
		image() {
			return require(`@/assets/${this.id}/1s.jpg`)
		},
		title() {
			return CARDS[this.id - 1].title
		},
		text() {
			return CARDS[this.id - 1].text
		},
		starClass() {
			return CARDS[this.id - 1].star
		},
		number() {
			let num = this.id
			if (num < 10) return '0' + num
			return num
		},
		isLower() {
			if (this.reverse) return (this.id - 1) % 2 === 0
			return (this.id - 1) % 2 !== 0
		},
	},
	methods: {
		toActivity() {
			ga('send', 'event', 'button', 'to activity', this.title)
		},
	},
}
</script>

<style scoped lang="less">
.card {
	width: 350px;
	display: flex;
	flex-direction: column;
	text-align: left;
	padding-bottom: 50px;
	position: relative;
	color: #fff;
	text-decoration: none;
}

.card.lower {
	transform: translateY(60px);
}

.card:hover {
	.image img {
		transform: scale(1.05);
	}

	.number {
		transform: translate(-35px, -30px);
	}
}

.image {
	width: 100%;
	overflow: hidden;
	z-index: 5;

	img {
		width: 100%;
		transition: all 1000ms ease;
	}
}

.title {
	margin-top: 16px;
	font-size: 22px;
	text-transform: uppercase;
	font-weight: 500;
	line-height: 24px;
}

.text {
	margin-top: 5px;
}

.number {
	position: absolute;
	font-size: 70px;
	top: 0;
	left: 0;
	transform: translate(-35px, -40px);
	transition: all 1000ms ease;
	z-index: 10;
	text-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
}

.badge {
	position: absolute;
	z-index: 10;
	right: 0;
}

.star {
	width: 140px;
	height: 140px;
	position: absolute;
	z-index: 0;

	.star-inner {
		width: 100%;
		height: 100%;
		background-image: url('../assets/star1.png');
		animation: spin 30s linear infinite;
		background-size: cover;
	}

	&.star1 {
		transform: translate(-60px, -60px);
		opacity: 0.5;
	}

	&.right {
		right: 0;
		transform: translate(60px, -60px);
	}

	&.star2 .star-inner {
		background-image: url('../assets/star2.png');
	}

	&.medium {
		width: 100px;
		height: 100px;
		transform: translate(-40px, -40px);
	}
	&.medium.right {
		width: 100px;
		height: 100px;
		transform: translate(40px, -40px);
	}
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

@media only screen and (max-device-width: 640px),
	only screen and (max-device-width: 736px),
	only screen and (max-width: 480px) {
	.card {
		width: 90vw;
		max-width: 350px;
		display: flex;
		flex-direction: column;
		text-align: left;
		padding-bottom: 50px;
		position: relative;
		color: #fff;
		text-decoration: none;
	}

	.card.lower {
		transform: translateY(0px);
	}

	.number {
		font-size: 50px;
		transform: translate(0px, -30px);
		z-index: 20;
	}

	.card:hover {
		.number {
			transform: translate(0px, -30px);
		}
	}
}
</style>
